/**
 * UTILS
 * 
 * functions utils pour l'ensemble
 * de la wishlist
 */
import $ from "jquery";
import { theme } from "../../../helpers/theme";
import { b64toblob } from "../../../helpers/b64toblob";
import { dialog } from "../../../components/dialog";
import { debug as debugCommon } from "../../../helpers/debug"; 
import { fileSaver } from 'file-saver';

const utils = (() => {
    const DEBUG = debugCommon.force();
    let context = null;
    let isContextPro = null;
    /**
     * DEBUG
     * 
     * function de debug
     * @param {string} key 
     * @param {*} val 
     */
    const debug = (key, val) => {
        if (DEBUG) console.log(key, val);
    };
    /**
     * DEFINE CONTEXT
     * 
     * definition du context PART/PRO
     */
    const defineContext = () => {
        context = theme.get();
    };
    /**
     * DISPATCH CUSTOM EVENT
     * 
     * @param {string} eventName nom de l'event
     * @param {object} params données envoyées à l'event 
     */
    const dispatchCustomEvent = (eventName, params) => {
        document.dispatchEvent(new CustomEvent(eventName, {
            detail: params
        }));
    };
    /**
     * DOWNLOAD
     * 
     * gestion du download de fichier
     * @param {string} filename 
     * @param {string} text 
     */
    const download = (filename, text) => {

        let splitExt = filename.split('.');
        let ext = splitExt[splitExt.length - 1];
        let file;
        if (ext !== 'pdf') {
            let blob = new Blob(['\ufeff' + text], { type: 'application/octet-stream' });
            blob.lastModifiedDate = new Date();
            file = blob;
        } else {
            let contentType = ext === 'pdf' ? 'application/pdf' : '';
            file = b64toblob.get(text, contentType);
        }
        if (window.saveAs) {
            window.saveAs(file, filename);
        } else if (navigator.saveBlob) {
            navigator.saveBlob(file, filename);
        } else {
            console.error('unable to save file', filename);
            dialog.close();
            utils.dispatchCustomEvent('TEMPLATE_ERROR', {error: 'unable to save file' });
        }

    };
    /**
     * GET CONTEXT
     * 
     * @returns {string}
     */
    const getContext = () => {
        if (null === context) {
            defineContext();
        }
        return context;
    };
    /**
     * GET DOM ADDRESS FROM ID
     * 
     * function de récupération d'un element
     * address dans le DOM
     * @param {string} id 
     * @returns {$}
     */
    const getDomAddressFromId = (id) => {
        return $(`.espace-connectee--address-item[data-address-id="${id}"]`);
    };
    /**
     * GET DOM DOC FROM ID
     * 
     * function de récupération d'un element
     * doc dans le DOM
     * @param {string} id 
     * @param {string} groupId 
     * @returns {$}
     */
    const getDomDocFromId = (id, groupId) => {
        return $(`.js-docs-list[data-docs-group-id="${groupId}"] tr[data-doc-id="${id}"]`);
    };
    /**
     * GET DOM LIST FROM ID
     * 
     * function de récupération d'un element
     * list dans le DOM
     * @param {string} id 
     * @returns {$}
     */
    const getDomListFromId = (id) => {
        return $(`.js-lists-list[data-id="${id}"]`);
    };
    /**
     * GET DOM PRODUCT FROM ID
     * 
     * function de récupération d'un element
     * product dans le DOM
     * @param {string} id 
     * @returns {$}
     */
    const getDomProductFromId = (id) => {
        return $(`.js-wishlist-product[data-id="${id}"]`);
    };
    /**
     * GET FORMATED DATE
     * 
     * formatage des dates
     * @param {*} timestamp 
     * @returns {string}
     */
    const getFormatedDate = (timestamp) => {
        let date = new Date(timestamp * 1000);
        let day = date.getDate()
                        .toString()
                        .padStart(2, '0');
        let month = (date.getMonth() + 1)
                        .toString()
                        .padStart(2, '0');
        let year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    /**
     * GET FORMATED PRICE
     * 
     * formatage des prix
     * @param {number} price 
     * @returns {string}
     */
    const getFormatedPrice = (price) => {
        return parseFloat(price).toFixed(2).toString().replace('.', ',') + "€";
    };
    /**
     * GET FORMATED FILE WEIGHT
     * 
     * formatage poids des fichiers
     * @param {number} bytes 
     * @returns {number}
     */
    const getFormatedFileWeight = function(bytes) {
        return parseFloat((bytes / 1048576).toFixed(2));
    };
    /**
     * GET QUERY VARIABLE
     * 
     * récupération d'une variable
     * d'URL
     * @param {string} variable 
     * @returns {bool|string}
     */
    const getQueryVariable = (variable) => {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i=0;i<vars.length;i++) {
                var pair = vars[i].split("=");
                if(pair[0] == variable){return pair[1];}
        }
        return(false);
    };
    /**
     * GET UNIQUE IDS
     * 
     * suppression des doublons
     * d'un array
     * @param {array} array 
     * @returns {array}
     */
    const getUniqueIds = (array) => {
        return [...new Set(array)];
    };
    /**
     * GET WISHLIST ID
     * @returns 
     */
    const getWishlistId = () => {
        let wlID = slug(window.WL.getWishlistName());
        if (userLogged()) {
            // si userlogged on cherche à récuperer wlId via
            // l'url
            if (getQueryVariable('wishlistid')) {
                wlID = slug(decodeURI(getQueryVariable('wishlistid')));
            } else if (window.location.hash.replace("#", '').length > 0) {
                wlID = slug(decodeURI(window.location.hash.replace("#", '')));
            }
        }
        return wlID;
    };
    /**
     * IS DESKTOP
     * 
     * @returns {bool}
     */
    const isDesktop = () => {
        return ( $('.is-desktop').css('display')  === 'block');
    }
    /**
     * IS PRO CONTEXT
     * 
     * @returns {bool}
     */
    const isProContext = () => {
        if (null === context) {
            defineContext();
        }
        return context;
    };
    /**
     * LINKS OBFUSCATION 
     */
    const linksObfuscation = () => {
        const target = '.js-obfuscation';
        const newElement = 'a';
        let attrsAll = [];
        $(target).each(function() {
            let attrs = {};
            $.each($(this)[0].attributes, function(index, attr) {
                let reg = new RegExp('(data-obfuscation-)([a-z]+)', 'g');
                const match = reg.exec(attr.nodeName);
                if (match && match[2] !== undefined){
                    attrs[match[2]] = attr.nodeValue;
                } else {
                    attrs[attr.nodeName] = attr.nodeValue;
                }
            });
            attrsAll.push(attrs);
        });
        $(target).replaceWith(function(index) {
            return $("<" + newElement + "/>", attrsAll[index]).append($(this).contents()).removeClass('obfuscation');
        });
    };
    /**
     * SLUG
     * 
     * @param {string} str 
     * @returns {string}
     */
    const slug = (str) => {
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();
      
        // remove accents, swap ñ for n, etc
        var from = "àáäâèééëêìíïîòóöôùúüûñç·/_,:;";
        var to   = "aaaaeeeeeiiiioooouuuunc------";
        for (var i=0, l=from.length ; i<l ; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }
    
        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-'); // collapse dashes
    
        return str;
    };
    /**
     * USER LOGGED
     * 
     * @returns {bool}
     */
    const userLogged = () => {
        return $('body').hasClass('user-logged');
    };
    /**
     * VALIDATE EMAIL
     * 
     * @param {string} email 
     * @returns {bool}
     */
    const validateEmail = (email) => {
        if (email === undefined) return false;
        var mailformat = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if (email.match(mailformat)) return true;
        return false;
    }

    return {
        debug,
        dispatchCustomEvent,
        download,
        getContext,
        getDomAddressFromId,
        getDomDocFromId,
        getDomListFromId,
        getDomProductFromId,
        getFormatedDate,
        getFormatedPrice,
        getFormatedFileWeight,
        getQueryVariable,
        getUniqueIds,
        getWishlistId,
        isDesktop,
        isProContext,
        linksObfuscation,
        slug,
        userLogged,
        validateEmail,
    }
})();
export default utils;